var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.artistName !== null)?_c('h1',[_vm._v(" "+_vm._s(_vm.artistName)+" ")]):_vm._e(),_vm._l((_vm.albums),function(album){return _c('album',{key:album.id,attrs:{"album":album}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }